export * from './ChevronLeft';
export * from './ChevronRight';
export * from './Plus';
export * from './Search';
export * from './Calendar';
export * from './Filter';
export * from './MapPin';
export * from './Trophy';
export * from './ArrowLeft'



// WEBPACK FOOTER //
// ./src/app/icons/index.js